import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { InputMask } from "primereact/inputmask";
import fglobales from "../../services/fglobales";
import * as Yup from "yup";
import { useFormik } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import Messages from "../messages/Messages";
import HubspotForm from "react-hubspot-form";
import { logEvents } from "../../services/f_analytics";

export default function Contacts() {
  const [submitted, setSubmitted] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [colorIcon, setColorIcon] = useState("green-500");
  const [icon, setIcon] = useState("pi-check-circle");
  const [headerMessage, setHeaderMessage] = useState(
    "¡Felicidades! El brief ha sido creado"
  );
  const [message, setMessage] = useState(
    "Tu registro ha sido creado exitosamente"
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      company: "",
      recaptcha: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("El nombre es requerido"),
      lastName: Yup.string().required("El apellido es requerido"),
      email: Yup.string().required("El e-mail es requerido"),
      phone: Yup.string().required("El Nro de teléfono es requerido"),
      company: Yup.string().required("La empresa es requerido"),
      recaptcha: Yup.string().required("El reCAPTCHA es requerido"),
    }),

    onSubmit: async (formData) => {
      try {
        setSubmitted(true);
        const result = await fglobales.addDoc("contacts", formData);
        setIcon(result.icon);
        setColorIcon(result.colorIcon);
        setHeaderMessage(result.headerMessage);
        setMessage(result.message);
        setShowMessage(true);
        setSubmitted(false);
        formik.resetForm();
      } catch (error) {
        setColorIcon("pink-500");
        setIcon("pi-times-circle");
        setHeaderMessage("Ha ocurrido un error");
        setMessage(
          "Tu registro no se ha podido crear correctamente, llame a soporte técnico."
        );
      }
    },
  });

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const actionHiddenMessage = () => {
    setShowMessage(false);
  };

  return (
    <>
      {/* <div className="formgrid grid mt-4">
        <div className="field col-12">
          <span className="p-float-label">
            <InputText
              id="firstName"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              className={classNames({
                "p-invalid": isFormFieldValid("firstName"),
              })}
              style={{ width: "100%" }}
              disabled={submitted}
            />
            <label htmlFor="firstName">Nombre</label>
          </span>
          {getFormErrorMessage("firstName")}
        </div>
        <div className="field col-12">
          <span className="p-float-label">
            <InputText
              id="lastName"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              className={classNames({
                "p-invalid": isFormFieldValid("lastName"),
              })}
              style={{ width: "100%" }}
              disabled={submitted}
            />
            <label htmlFor="lastName">Apellido</label>
          </span>
          {getFormErrorMessage("lastName")}
        </div>
        <div className="field col-12">
          <span className="p-float-label">
            <InputText
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              className={classNames({
                "p-invalid": isFormFieldValid("email"),
              })}
              style={{ width: "100%" }}
              disabled={submitted}
            />
            <label htmlFor="email">Email</label>
          </span>
          {getFormErrorMessage("email")}
        </div>
        <div className="field col-12">
          <span className="p-float-label">
            <InputMask
              id="phone"
              name="phone"
              mask="(999) 999-9999"
              value={formik.values.phone}
              placeholder="(999) 999-9999"
              onChange={(e) => formik.setFieldValue("phone", e.value)}
              disabled={submitted}
              style={{ width: "100%" }}
            ></InputMask>
            <label htmlFor="phone">Nro. de teléfono</label>
          </span>
          {getFormErrorMessage("phone")}
        </div>
        <div className="field col-12">
          <span className="p-float-label">
            <InputText
              id="company"
              name="company"
              value={formik.values.company}
              onChange={formik.handleChange}
              className={classNames({
                "p-invalid": isFormFieldValid("company"),
              })}
              style={{ width: "100%" }}
              disabled={submitted}
            />
            <label htmlFor="company">Empresa</label>
          </span>
          {getFormErrorMessage("company")}
        </div>
        <div className="field col-12">
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={(value) => {
              formik.setFieldValue("recaptcha", value);
            }}
          />
          {getFormErrorMessage("recaptcha")}
        </div>
        <div className="field col-12">
          <button
            type="button"
            onClick={() => formik.submitForm()}
            className="buttonRed"
            disabled={formik.isValid && formik.dirty && formik.isSubmitting}
          >
            {submitted ? "Cargando..." : "Enviar"}
          </button>
        </div>
      </div> */}
      <HubspotForm
        portalId="39847893"
        formId="f5aaa211-3fd7-4901-801b-49c39d430f2d"
        onSubmit={() => {
          logEvents("form", "contact form");
          console.log("Submit!")
        }}
        onReady={(form) => console.log("Form ready!")}
        loading={<div>Loading...</div>}
      />
      <Messages
        showMessage={showMessage}
        actionHidden={actionHiddenMessage}
        headerMessage={headerMessage}
        message={message}
        icon={icon}
        color={colorIcon}
      />
    </>
  );
};